import html2canvas from 'html2canvas';

interface ShareOptions {
  title: string;
  text: string;
  url: string;
  image?: string;
  hashtags?: string[];
}

export const shareToSocial = async (
  platform: 'twitter' | 'facebook' | 'linkedin' | 'native',
  options: ShareOptions
) => {
  const { title, text, url, hashtags = [] } = options;
  const hashtagString = hashtags.join(',');

  switch (platform) {
    case 'twitter':
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          text
        )}&url=${encodeURIComponent(url)}&hashtags=${hashtagString}`,
        '_blank'
      );
      break;

    case 'facebook':
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(
          url
        )}`,
        '_blank'
      );
      break;

    case 'linkedin':
      window.open(
        `https://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
          url
        )}&title=${encodeURIComponent(title)}&summary=${encodeURIComponent(
          text
        )}`,
        '_blank'
      );
      break;

    case 'native':
      if (navigator.share) {
        try {
          await navigator.share({
            title,
            text,
            url,
          });
        } catch (error) {
          console.error('Error sharing:', error);
        }
      } else {
        // Fallback to clipboard
        const shareText = `${title}\n\n${text}\n\n${url}`;
        await navigator.clipboard.writeText(shareText);
      }
      break;
  }
};

export const downloadImage = async (elementId: string, fileName: string) => {
  const element = document.getElementById(elementId);
  if (!element) return;

  try {
    const canvas = await html2canvas(element, {
      backgroundColor: null,
      scale: 2,
    });

    const link = document.createElement('a');
    link.download = fileName;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } catch (error) {
    console.error('Error generating image:', error);
  }
};
